import { trialConfig } from "../utils/trialConfig";

export default function TrialPaymentInfo() {
  return (
    <div className="p-6 space-y-3 border border-yellow-300 bg-yellow-50 dark:bg-yellow-900/20 dark:border-yellow-800 rounded-xl">
      <h4 className="text-lg font-semibold text-yellow-800 dark:text-yellow-300">
        💳 Skema Pembayaran
      </h4>

      <p className="text-sm text-gray-700 dark:text-gray-300">
        Trial Demo ini <b>GRATIS selama {trialConfig.durationDays} hari</b>.
        Tidak ada pembayaran di awal.
      </p>

      <div className="p-4 bg-white border rounded-lg dark:bg-gray-900">
        <ul className="space-y-1 text-sm text-gray-700 dark:text-gray-300">
          <li>
            Harga normal: <b>Rp {trialConfig.priceNormal.toLocaleString()}</b>
          </li>
          <li>
            Diskon trial: <b>{trialConfig.discountPercent}%</b>
          </li>
          <li>
            Bayar jika lanjut:{" "}
            <b>Rp {trialConfig.payAfterTrial.toLocaleString()}</b>
          </li>
        </ul>
      </div>
    </div>
  );
}
